import React from "react";
import { Drawer } from "vaul";
import { GroupsSection } from "./GroupsSection";
import { PlayerBreakdownSection } from "./PlayerBreakdownSection";
import { PrizeMoneySection } from "./PrizeMoneySection";

function isInsidePlayerStatsOverlay(target) {
    return (
        target instanceof Element &&
        Boolean(target.closest("[data-player-stats-overlay]"))
    );
}

function isInsidePastWinnersOverlay(target) {
    return (
        target instanceof Element &&
        Boolean(target.closest("[data-past-winners-overlay]"))
    );
}

export function MoreMenuDrawer({
    open,
    onOpenChange,
    sheetTab,
    onSheetTabChange,
    moneyBreakdown,
    prizeMoney,
    formatter,
    pairingGroups = [],
    competitionPeriod = 1,
}) {
    return (
        <Drawer.Root open={open} onOpenChange={onOpenChange} modal>
            <Drawer.Portal>
                <Drawer.Overlay className="fixed inset-0 z-40 bg-black/50 backdrop-blur-[2px]" />
                <Drawer.Content
                    className="fixed bottom-0 left-0 right-0 z-50 flex h-[66vh] max-h-[66vh] flex-col rounded-t-2xl border border-masters-moss/40 border-b-0 bg-masters-forest shadow-2xl outline-none"
                    onPointerDownOutside={(e) => {
                        const orig = e.detail?.originalEvent;
                        const t = orig?.target;
                        if (
                            isInsidePlayerStatsOverlay(t) ||
                            isInsidePastWinnersOverlay(t)
                        ) {
                            e.preventDefault();
                        }
                    }}
                >
                    <div className="mx-auto mt-3 h-1.5 w-12 shrink-0 rounded-full bg-masters-moss/70" />
                    <Drawer.Title className="sr-only">
                        Leaderboard, prize money, and playing groups
                    </Drawer.Title>
                    <Drawer.Description className="sr-only">
                        View tournament leaderboard breakdown, prize money table,
                        or tee groups.
                    </Drawer.Description>

                    <div className="flex shrink-0 flex-wrap justify-center gap-2 px-4 pb-2 pt-4">
                        <button
                            type="button"
                            onClick={() => onSheetTabChange("breakdown")}
                            className={`rounded-full px-3 py-2 text-sm font-medium transition-colors sm:px-4 ${
                                sheetTab === "breakdown"
                                    ? "bg-masters-cream text-masters-forest ring-1 ring-masters-gold/35"
                                    : "border border-masters-moss/60 bg-masters-pine/50 text-masters-cream/85 hover:bg-masters-pine/70"
                            }`}
                        >
                            Leaderboard
                        </button>
                        <button
                            type="button"
                            onClick={() => onSheetTabChange("prize")}
                            className={`rounded-full px-3 py-2 text-sm font-medium transition-colors sm:px-4 ${
                                sheetTab === "prize"
                                    ? "bg-masters-cream text-masters-forest ring-1 ring-masters-gold/35"
                                    : "border border-masters-moss/60 bg-masters-pine/50 text-masters-cream/85 hover:bg-masters-pine/70"
                            }`}
                        >
                            Monies
                        </button>
                        <button
                            type="button"
                            onClick={() => onSheetTabChange("groups")}
                            className={`rounded-full px-3 py-2 text-sm font-medium transition-colors sm:px-4 ${
                                sheetTab === "groups"
                                    ? "bg-masters-cream text-masters-forest ring-1 ring-masters-gold/35"
                                    : "border border-masters-moss/60 bg-masters-pine/50 text-masters-cream/85 hover:bg-masters-pine/70"
                            }`}
                        >
                            Groups
                        </button>
                    </div>

                    <div
                        className={`min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 pb-8 pt-4 ${
                            sheetTab === "breakdown" ? "block" : "hidden"
                        }`}
                        aria-hidden={sheetTab !== "breakdown"}
                    >
                        <PlayerBreakdownSection
                            moneyBreakdown={moneyBreakdown}
                            formatter={formatter}
                        />
                    </div>
                    <div
                        className={`min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 pb-8 pt-4 ${
                            sheetTab === "prize" ? "block" : "hidden"
                        }`}
                        aria-hidden={sheetTab !== "prize"}
                    >
                        <PrizeMoneySection
                            prizeMoney={prizeMoney}
                            formatter={formatter}
                        />
                    </div>
                    <div
                        className={`min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 pb-8 pt-4 ${
                            sheetTab === "groups" ? "block" : "hidden"
                        }`}
                        aria-hidden={sheetTab !== "groups"}
                    >
                        <GroupsSection
                            pairingGroups={pairingGroups}
                            competitionPeriod={competitionPeriod}
                        />
                    </div>
                </Drawer.Content>
            </Drawer.Portal>
        </Drawer.Root>
    );
}
